import { connect } from 'react-redux'
import MainView from '../components/MainView'
import {loadProducts} from "../../../components/ShoppingCart/modules/shoppingCart";
import {getUser} from '../../Login/modules/user'

const mapDispatchToProps = {
  loadProducts: loadProducts,
  getUser: getUser
};

const mapStateToProps = (state) => ({
  language: state.i18n.locale,
  showTimeoutPopup: state.timer.timeout_popup
});


export default connect(mapStateToProps, mapDispatchToProps)(MainView)


// WEBPACK FOOTER //
// ./src/routes/Main/containers/MainContainer.js